import { SCALE, SCALE_V, TILE_SIZE } from "../utils/constants";
import UIMenus from "./UIMenus";
import Dialogs from "./Dialogs";
import dbManager from "../utils/dbManager";
import * as Controller from "./Controller/Controller";

export default class UI {
  constructor(scene, noScores) {
    this.scene = scene;
    this.inGameMenu = null;
    this.setUpPuseResumeGame();
    this.mushroomsIcon = null;
    this.diamondsIcon = null;

    this.scene.events.off("game_paused");
    this.scene.events.on("game_paused", () => this.showPauseMenu());
    this.scene.events.off("game_resumed");
    this.scene.events.on("game_resumed", () => this.hidePauseMenu());

    const rockHit1 = this.scene.sound.add("rock_hit");
    const rockHit2 = this.scene.sound.add("rock_hit2");
    const rockHit3 = this.scene.sound.add("rock_hit3");
    const rockHit = [rockHit1, rockHit2, rockHit3];
    this.scene.events.off("sounds:rock_hit_hard");
    this.scene.events.on("sounds:rock_hit_hard", () =>
      rockHit[Math.trunc(Math.random() * 10) % 3].play()
    );

    const rockSlideHard1 = this.scene.sound.add("rock_slide_hard1");
    const rockSlideHard2 = this.scene.sound.add("rock_slide_hard2");
    const rockSlideHard3 = this.scene.sound.add("rock_slide_hard3");
    const rockSlideHard = [rockSlideHard1, rockSlideHard2, rockSlideHard3];
    this.scene.events.off("sounds:rock_slide_hard");
    this.scene.events.on("sounds:rock_slide_hard", () =>
      rockSlideHard[Math.trunc(Math.random() * 10) % 3].play()
    );

    const rockSlideSoft1 = this.scene.sound.add("rock_slide_soft1");
    const rockSlideSoft2 = this.scene.sound.add("rock_slide_soft2");
    const rockSlideSoft3 = this.scene.sound.add("rock_slide_soft3");
    const rockSlideSoft = [rockSlideSoft1, rockSlideSoft2, rockSlideSoft3];
    this.scene.events.off("sounds:rock_slide_soft");
    this.scene.events.on("sounds:rock_slide_soft", () =>
      rockSlideSoft[Math.trunc(Math.random() * 10) % 3].play()
    );

    const rockHitSoft = this.scene.sound.add("rock_hit_soft");
    this.scene.events.off("sounds:rock_hit_soft");
    this.scene.events.on("sounds:rock_hit_soft", () => rockHitSoft.play());

    const gemHit = this.scene.sound.add("gem_hit");
    this.scene.events.off("sounds:gem_hit");
    this.scene.events.on("sounds:gem_hit", () => gemHit.play());

    const explosion = this.scene.sound.add("explosion");
    this.scene.events.off("sounds:explosion");
    this.scene.events.on("sounds:explosion", () => explosion.play());

    const shroomPick = this.scene.sound.add("shroom_pick");
    this.scene.events.off("sounds:shroom_pick");
    this.scene.events.on("sounds:shroom_pick", () => shroomPick.play());

    const gemPick = this.scene.sound.add("gem_pick");
    this.scene.events.off("sounds:gem_pick");
    this.scene.events.on("sounds:gem_pick", () => gemPick.play());

    const coinPick = this.scene.sound.add("coin");
    this.scene.events.off("sounds:coin");
    this.scene.events.once("sounds:coin", () => coinPick.play());

    const clearHit1 = this.scene.sound.add("clear_hit1");
    const clearHit2 = this.scene.sound.add("clear_hit2");
    const clearHit3 = this.scene.sound.add("clear_hit3");
    const clearHit = [clearHit1, clearHit2, clearHit3];
    this.scene.events.off("sounds:clear_hit");
    this.scene.events.on("sounds:clear_hit", () =>
      clearHit[Math.trunc(Math.random() * 10) % 3].play()
    );

    const deathByRockHit = this.scene.sound.add("death_by_rock");
    this.scene.events.off("sounds:death_by_rock_hit");
    this.scene.events.on("sounds:death_by_rock_hit", () =>
      deathByRockHit.play()
    );

    const levelComplete = this.scene.sound.add("level_complete");
    this.scene.events.off("sounds:level_complete");
    this.scene.events.on("sounds:level_complete", () => levelComplete.play());
    if (!noScores) {
      this.drawScores();
    }

    this.dialogs = new Dialogs(this.scene);
    this.scene.events.off("dialogue:show");
    this.scene.events.on("dialogue:show", (props) => {
      this.scene.levels?.current?.pause();
      this.dialogs.mount();
      this.dialogs.showDialog(props);
    });
    this.scene.events.off("dialogue:updateCharacterName");
    this.scene.events.on(
      "dialogue:updateCharacterName",
      async ({ key, name }) => {
        this.dialogs.updateCharacterName(key, name);
      }
    );
    this.scene.events.off("dialogue:nextPage");
    this.scene.events.on("dialogue:nextPage", async (skipAmount = 0) => {
      // console.log(this.dialogs.currentDialogIndex, this.dialogs.conversation);
      this.dialogs.currentDialogIndex += skipAmount;
      this.dialogs.showMessage(
        this.dialogs.conversation[++this.dialogs.currentDialogIndex]
      );
    });
    this.scene.events.off("dialogue:hide");
    this.scene.events.on("dialogue:hide", async () => {
      await this.dialogs.hideDialog();
      this.scene.events.emit("dialogue:hidden");
      this.dialogs.unmount();
      this.scene.levels?.current?.resume();
    });

    this.topWindowboxing = this.scene.add.graphics();
    this.topWindowboxing.fillStyle(0x000000, 1);
    this.topWindowboxing.fillRect(
      0,
      -UI.tileToScreen(9),
      UI.tileToScreen(20),
      UI.tileToScreen(10)
    );
    // hidden
    this.topWindowboxing.y = -UI.tileToScreen(1.5);
    this.topWindowboxing.setScrollFactor(0);
    this.topWindowboxing.depth = 110;

    const tilesByHeight =
      document.querySelector("canvas").height / (TILE_SIZE * SCALE);
    // console.log({ tilesByHeight });
    this.bottomWindowboxing = this.scene.add.graphics();
    this.bottomWindowboxing.fillStyle(0x000000, 1);
    this.bottomWindowboxing.fillRect(
      0,
      UI.tileToScreen(tilesByHeight - 1),
      UI.tileToScreen(20),
      UI.tileToScreen(10)
    );
    // hidden
    this.bottomWindowboxing.y = UI.tileToScreen(1.5);
    this.bottomWindowboxing.setScrollFactor(0);
    this.bottomWindowboxing.depth = 110;
  }

  setWindowBoxBehaviour() {
    const layerScores = this.scoresLayer;
    // console.log(this.scene.children, layerScores);
    if (!layerScores) {
      return false;
    }
    const originalValues = {
      topY: this.topWindowboxing?.y || 0,
      botY: this.bottomWindowboxing?.y || 0,
      lsY: layerScores?.y,
      dsY: this.diamondsScore?.y || 0,
      diY: this.diamondsIcon?.y || 0,
      miY: this.mushroomsIcon?.y || 0,
      msY: this.mushroomsScore?.y || 0,
      dsgY: this.diamondsScoreGoal?.y || 0,
      pbarY: 0, // boss progress bar
      pboxY: 0, // boss progress box
    };

    this.scene.events.off("player:disconnected");
    this.scene.events.on("player:disconnected", () => {
      const targetObj = {
        y: 0,
      };
      originalValues.topY = this.topWindowboxing?.y || 0;
      originalValues.botY = this.bottomWindowboxing?.y || 0;
      originalValues.dsgY = this.diamondsScoreGoal?.y || 0;
      originalValues.dsY = this.diamondsScore?.y || 0;
      const circularProgress =
        this.scene.children.getByName("circularProgress");
      const progressBar1 = this.scene.children.getByName("progressBar1");
      const progressBox1 = this.scene.children.getByName("progressBox1");
      const progressBar2 = this.scene.children.getByName("progressBar2");
      const progressBox2 = this.scene.children.getByName("progressBox2");
      const progressBar3 = this.scene.children.getByName("progressBar3");
      const progressBox3 = this.scene.children.getByName("progressBox3");
      originalValues.circY =
        circularProgress?.y || UI.tileToPixels(4);
      originalValues.pbar1Y = progressBar1?.y || UI.tileToPixels(3.75);
      originalValues.pbox1Y = progressBox1?.y || UI.tileToPixels(3.75);
      originalValues.pbar2Y = progressBar2?.y || UI.tileToPixels(3.75);
      originalValues.pbox2Y = progressBox2?.y || UI.tileToPixels(3.75);
      originalValues.pbar3Y = progressBar3?.y || UI.tileToPixels(3.75);
      originalValues.pbox3Y = progressBox3?.y || UI.tileToPixels(3.75);
      this.scene.tweens.add({
        targets: targetObj,
        y: UI.tileToPixels(5),
        ease: "Linear",
        duration: 250,
        onUpdate: (tween, target) => {
          this.topWindowboxing.y = originalValues.topY + target.y;
          this.bottomWindowboxing.y = originalValues.botY - target.y;
          layerScores.y = originalValues.lsY - target.y;
          this.diamondsScore &&
            (this.diamondsScore.y = originalValues.dsY - target.y);
          this.diamondsIcon &&
            (this.diamondsIcon.y = originalValues.diY - target.y);
          this.mushroomsIcon &&
            (this.mushroomsIcon.y = originalValues.miY - target.y);
          this.mushroomsScore &&
            (this.mushroomsScore.y = originalValues.msY - target.y);
          this.diamondsScoreGoal &&
            (this.diamondsScoreGoal.y = originalValues.dsgY - target.y);
          circularProgress &&
            (circularProgress.y = originalValues.circY - target.y);
          progressBar1 && (progressBar1.y = originalValues.pbar1Y - target.y);
          progressBox1 && (progressBox1.y = originalValues.pbox1Y - target.y);
          progressBar2 && (progressBar2.y = originalValues.pbar2Y - target.y);
          progressBox2 && (progressBox2.y = originalValues.pbox2Y - target.y);
          progressBar3 && (progressBar3.y = originalValues.pbar3Y - target.y);
          progressBox3 && (progressBox3.y = originalValues.pbox3Y - target.y);
        },
      });
    });
    this.scene.events.off("player:reconnected");
    this.scene.events.on("player:reconnected", () => {
      const layerScores = this.scene.children.getByName("layer_scores");
      const targetObj = {
        y: UI.tileToPixels(5),
      };

      const circularProgress =
        this.scene.children.getByName("circularProgress");
      const progressBar1 = this.scene.children.getByName("progressBar1");
      const progressBox1 = this.scene.children.getByName("progressBox1");
      const progressBar2 = this.scene.children.getByName("progressBar2");
      const progressBox2 = this.scene.children.getByName("progressBox2");
      const progressBar3 = this.scene.children.getByName("progressBar3");
      const progressBox3 = this.scene.children.getByName("progressBox3");

      this.scene.tweens.add({
        targets: targetObj,
        y: 0,
        ease: "Linear",
        duration: 1000,
        onUpdate: (tween, target) => {
          this.topWindowboxing.y = originalValues.topY - (1 - target.y);
          this.bottomWindowboxing.y = originalValues.botY + (1 - target.y);
          layerScores.y = originalValues.lsY - target.y;
          this.diamondsScore &&
            (this.diamondsScore.y = originalValues.dsY - target.y);
          this.diamondsIcon &&
            (this.diamondsIcon.y = originalValues.diY - target.y);
          this.mushroomsIcon &&
            (this.mushroomsIcon.y = originalValues.miY - target.y);
          this.mushroomsScore &&
            (this.mushroomsScore.y = originalValues.msY - target.y);
          this.diamondsScoreGoal &&
            (this.diamondsScoreGoal.y = originalValues.dsgY - target.y);
          circularProgress &&
            (circularProgress.y = originalValues.circY - target.y);
          progressBar1 && (progressBar1.y = originalValues.pbar1Y - target.y);
          progressBox1 && (progressBox1.y = originalValues.pbox1Y - target.y);
          progressBar2 && (progressBar2.y = originalValues.pbar2Y - target.y);
          progressBox2 && (progressBox2.y = originalValues.pbox2Y - target.y);
          progressBar3 && (progressBar3.y = originalValues.pbar3Y - target.y);
          progressBox3 && (progressBox3.y = originalValues.pbox3Y - target.y);
        },
      });
    });
  }

  destroy() {
    this.mushroomsIcon?.destroy();
    this.diamondsIcon?.destroy();
    this.mushroomsScore?.destroy();
    this.diamondsScore?.destroy();
    this.diamondsScoreGoal?.destroy();
    this.scene.events.off("score:diamond_goal");
    this.scene.events.off("score:diamond_set");
    this.scene.events.off("score:diamond_goal_set");
    this.scene.events.off("score:mushroom_collected");
    this.scene.events.off("score:mushroom_given");
  }
  onResize() {
    const layer = this.scene.children.getByName("layer_scores");
    if (!layer) return false;

    this.mushroomsIcon
      .setPosition(UI.tileToScreen(18), UI.tileToScreen(1))
      .setScale(SCALE * 1.5);

    const shroomsAmount = window.localStorage.getItem("shrooms") || "0";
    this.mushroomsScore?.setPosition(
      UI.tileToScreen(20) - this.MT_MARGIN_RIGHT,
      // map.tileToWorldY(1)
      UI.tileToScreen(1)
    );
    this.mushroomsScore?.setScrollFactor(0);
    this.mushroomsScore && (this.mushroomsScore.displayHeight = 10 * SCALE);
    this.mushroomsScore &&
      (this.mushroomsScore.displayWidth = shroomsAmount.length * 10 * SCALE);

    this.diamondsIcon
      .setPosition(UI.tileToScreen(1) + this.D_MARGIN_LEFT, UI.tileToScreen(1))
      .setScale(SCALE * 1.5);

    this.diamondsScoreGoal?.setPosition(
      UI.tileToScreen(3) - this.DT_MARGIN_RIGHT,
      UI.tileToScreen(1)
    );
    this.diamondsScoreGoal &&
      (this.diamondsScoreGoal.displayHeight = 8 * SCALE);
    this.diamondsScoreGoal &&
      (this.diamondsScoreGoal.displayWidth = 2 * 8 * SCALE);

    this.diamondsScore?.setPosition(
      UI.tileToScreen(3) - this.DT_MARGIN_RIGHT,
      UI.tileToScreen(1) - this.diamondsScoreGoal?.test !== "00"
        ? UI.tileToScreen(0.5)
        : 0
    );
    this.diamondsScore && (this.diamondsScore.displayHeight = 10 * SCALE);
    this.diamondsScore &&
      (this.diamondsScore.displayWidth =
        this.diamondsAmount.length * 10 * SCALE);
  }

  hidePauseMenu() {
    const layer = this.scene.children.list.find(
      (el) => el.name === "layer_pause_nenu"
    );
    if (layer) {
      layer.setVisible(false);
      // flag to avoid options to work after menu is hidden
      this.inGameMenu.isVisible = false;
    }
    this.scene.children.list
      .filter((el) => el.name.includes("menu_text"))
      .forEach((el) => el.destroy());
    this.scene.children.list
      .filter((el) => el.name.includes("_tn_to_remove"))
      .forEach((el) => el.destroy());

    this.scene.children.list
      .filter((el) => el.name.includes("layer_arrow"))
      .forEach((el) => el.destroy());
    // this.scene.children.list.filter(el => el.name.includes('layer_pause_nenu')).forEach(el => el.destroy())
  }

  preapreScoreTilemap() {
    // Creating a blank tilemap with dimensions matching the dungeon
    const map = this.scene.make.tilemap({
      tileWidth: 20,
      tileHeight: 20,
      width: 20,
      height: 20,
    });
    // addTilesetImage: function (tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid)
    map.addTilesetImage("hud-tiles", "hud-tiles", 20, 20, 1, 2);

    let scoreTileset = map.addTilesetImage(
      "hud-tiles",
      "hud-tiles",
      20,
      20,
      1,
      2
    );

    let scoresLayer = map.createBlankLayer("layer_scores", scoreTileset);
    scoresLayer.name = "layer_scores";
    scoresLayer.depth = 6;
    scoresLayer.setScrollFactor(0);

    scoresLayer.setScale(SCALE);
    this.scoresLayer = scoresLayer;
    // console.log(this.scoresLayer);

    return map;
  }

  drawKiBossScores() {
    const map = this.preapreScoreTilemap();

    // LEFT
    Dialogs.drawWindow(map, { w: 3, h: 2, x: 0, y: 0 });

    // RIGHT
    Dialogs.drawWindow(map, { w: 3, h: 2, x: 17, y: 0 });

    const msh = this.scene.add
      .sprite(map.tileToWorldX(18), map.tileToWorldY(1))
      .play("closeUp_Abushgidim")
      .setOrigin(0.5, 0.5)
      .setScale(SCALE());
    msh.depth = 16;
    msh.name = "score_right_img";
    msh.setScrollFactor(0);
    this.mushroomsIcon = msh;

    const D_MARGIN_LEFT_PX = -2; //px
    this.D_MARGIN_LEFT = D_MARGIN_LEFT_PX * SCALE;
    const diamond = this.scene.add
      .sprite(
        map.tileToWorldX(1) + this.D_MARGIN_LEFT,
        map.tileToWorldY(1) + 2 * SCALE()
      )
      .play("closeUp_tentacles")
      .setOrigin(0.5, 0.5)
      .setScale(SCALE());
    diamond.depth = 16;
    diamond.name = "score_left_img";
    diamond.setScrollFactor(0);
    this.diamondsIcon = diamond;

    this.setWindowBoxBehaviour();
  }
  async drawScores() {
    const map = this.preapreScoreTilemap();

    // LEFT
    Dialogs.drawWindow(map, { w: 3, h: 2, x: 0, y: 0 });

    // RIGHT
    Dialogs.drawWindow(map, { w: 3, h: 2, x: 17, y: 0 });

    // this.pickaxeScore = window.localStorage.getItem('pickaxe')
    // const s = this.scene.add.sprite(
    //   map.tileToWorldX(9) + 10 * SCALE,
    //   map.tileToWorldY(0) + 10 * SCALE,
    // ).play('closeUp_Pickaxe').setOrigin(0.1, 0.15).setScale(SCALE)
    // s.depth = 6
    // s.setScrollFactor(0)
    // s.setVisible(this.pickaxeScore === 'true')

    const msh = this.scene.add
      .sprite(map.tileToWorldX(18), map.tileToWorldY(1))
      .play("closeUp_Mushroom")
      .setOrigin(0.5, 0.5)
      .setScale(SCALE * 1.5);
    msh.depth = 6;
    msh.name = "score_img";
    msh.setScrollFactor(0);
    this.mushroomsIcon = msh;

    const MT_MARGIN_RIGHT_PX = 9;
    this.MT_MARGIN_RIGHT = MT_MARGIN_RIGHT_PX * SCALE;
    // const shroomsAmount = window.localStorage.getItem("shrooms") || "0";
    // console.log(dbManager.getLevels())
    // const shroomsAmount = dbManager.getLevels().reduce((r, l) => r + l.collectedShrooms, 0);
    // console.log(await dbManager.get("totalShroomsAmount"));
    const shroomsAmount = Math.max(
      (await dbManager.get("totalShroomsAmount")) || 0,
      0
    );
    this.mushroomsScore = this.scene.add.text(
      map.tileToWorldX(20) - this.MT_MARGIN_RIGHT,
      map.tileToWorldY(1),
      String(shroomsAmount),
      {
        fontFamily: "GameGirl",
        fill: "#ffffff",
        align: "right",
      }
    );
    this.mushroomsScore.setData("amount", shroomsAmount);
    this.mushroomsScore.setOrigin(1, 0);
    this.mushroomsScore.displayHeight = 10 * SCALE;
    this.mushroomsScore.displayWidth =
      String(shroomsAmount).length * 10 * SCALE;
    this.mushroomsScore.name = "score_text_to_remove";
    this.mushroomsScore.depth = 6;
    this.mushroomsScore.setScrollFactor(0);
    this.mushroomsScore.setShadow(-1, 1);

    const D_MARGIN_LEFT_PX = 0.5; //px
    this.D_MARGIN_LEFT = D_MARGIN_LEFT_PX * SCALE;
    const diamond = this.scene.add
      .sprite(map.tileToWorldX(1) + this.D_MARGIN_LEFT, map.tileToWorldY(1))
      .play("closeUp_Diamond")
      .setOrigin(0.5, 0.5)
      .setScale(SCALE * 1.5);
    diamond.depth = 6;
    diamond.name = "score_img";
    diamond.setScrollFactor(0);
    this.diamondsIcon = diamond;

    this.scene.events.once("score:diamond_goal", () => {
      this.scene.tweens.add({
        targets: diamond,
        scale: SCALE * 2,
        ease: "Linear",
        duration: 250,
        yoyo: true,
        // onComplete: () => {
        //   this.music.stop()
        // },
      });
    });

    const DT_MARGIN_RIGHT_PX = 9;
    this.DT_MARGIN_RIGHT = DT_MARGIN_RIGHT_PX * SCALE;
    this.diamondsAmount = "0";
    this.diamondsScore = this.scene.add.text(
      map.tileToWorldX(3) - this.DT_MARGIN_RIGHT,
      map.tileToWorldY(1),
      // map.tileToWorldY(0.5),
      this.diamondsAmount,
      {
        fontFamily: "GameGirl",
        fill: "#ffffff",
        align: "right",
      }
    );
    this.diamondsScore.setOrigin(1, 0);
    this.diamondsScore.displayHeight = 10 * SCALE;
    this.diamondsScore.displayWidth = this.diamondsAmount.length * 10 * SCALE;
    this.diamondsScore.name = "score_text_to_remove";
    this.diamondsScore.depth = 6;
    this.diamondsScore.setScrollFactor(0);
    this.diamondsScore.setShadow(-1, 1);

    this.diamondsScoreGoal = this.scene.add.text(
      map.tileToWorldX(3) - this.DT_MARGIN_RIGHT,
      map.tileToWorldY(1),
      "00", // goal
      {
        fontFamily: "GameGirl",
        fill: "gold",
        align: "right",
      }
    );
    this.diamondsScoreGoal.alpha = 0;
    this.diamondsScoreGoal.setOrigin(1, 0);
    this.diamondsScoreGoal.displayHeight = 8 * SCALE;
    this.diamondsScoreGoal.displayWidth = 2 * 8 * SCALE;
    this.diamondsScoreGoal.name = "score_text_to_remove";
    this.diamondsScoreGoal.depth = 6;
    this.diamondsScoreGoal.setScrollFactor(0);
    this.diamondsScoreGoal.setShadow(-1, 1);

    this.scene.events.on("score:mushroom_collected", (howMany = 1) => {
      const amount = this.mushroomsScore.getData("amount") + howMany;
      this.mushroomsScore.setText(amount);
    });
    this.scene.events.on("score:mushroom_given", (howMany = 1) => {
      const amount = Number(this.mushroomsScore.getData("amount")) - howMany;
      this.mushroomsScore.setText(String(amount));
    });
    window.scene = this.scene;

    this.scene.events.on("score:diamond_set", (amount) => {
      this.diamondsAmount = amount;
      this.diamondsScore.setText(amount);
    });

    this.scene.events.once("score:diamond_goal_set", (amount) => {
      this.scene.tweens.add({
        targets: this.diamondsScore,
        y: UI.tileToScreen(0.5),
        ease: "Linear",
        duration: 250,
        onComplete: () => {},
      });
      const targetPosX = this.diamondsScoreGoal.x;
      this.diamondsScoreGoal.x += UI.tileToScreen(0.5);
      this.diamondsScoreGoal.alpha = 0;
      this.diamondsScoreGoal.setText(amount);
      this.scene.tweens.add({
        targets: this.diamondsScoreGoal,
        x: targetPosX,
        alpha: 1,
        ease: "Linear",
        duration: 250,
        delay: 200,
      });
    });

    this.setWindowBoxBehaviour();
  }

  drawMenuOptions(map) {
    this.inGameMenu = new UIMenus(this.scene);
    this.inGameMenu.showInGameMenu();
  }

  showPauseMenu() {
    const existingLayer = this.scene.children.list.find(
      (el) => el.name === "layer_pause_nenu"
    );
    // flag to avoid options to work after menu is hidden
    if (existingLayer) {
      existingLayer.setVisible(true);
      this.drawMenuOptions();
      this.inGameMenu.isVisible = true;
      return true;
    }

    // Creating a blank tilemap with dimensions matching the dungeon
    const map = this.scene.make.tilemap({
      tileWidth: 20,
      tileHeight: 20,
      width: 20,
      height: 20,
    });
    // addTilesetImage: function (tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid)
    let tileset = map.addTilesetImage("hud-tiles", "hud-tiles", 20, 20, 1, 2);

    let layer = map.createBlankLayer("layer_pause_nenu", tileset);
    layer.name = "layer_pause_nenu";
    layer.depth = 15;
    layer.setScrollFactor(0);

    layer.setScale(SCALE);

    Dialogs.drawWindow(map, { w: 14, h: 3, x: 3, y: 0 });
    this.drawMenuOptions(map);
    this.inGameMenu.isVisible = true;
  }

  setUpPuseResumeGame() {
    this.scene.input.keyboard.removeListener(
      "keydown",
      this.onKeyDown.bind(this)
    );
    this.scene.input.keyboard.addListener("keydown", this.onKeyDown.bind(this));
  }

  onKeyDown(event) {
    const pauseGame = () => {
      this.scene.levels.current.pause();
      this.scene.events.emit("game_paused");
    };
    const resumeGame = () => {
      this.scene.levels.current.resume();
      this.scene.events.emit("game_resumed");
    };
    if (
      Controller.isCancel(event.key) &&
      !this.dialogs.isShowing &&
      this.scene.levels.current.player.connected
    ) {
      const action = this.scene.levels.current.isPaused
        ? resumeGame
        : pauseGame;
      action();
    }
  }

  // HELPER
  static tileToScreen(val = 0) {
    return UI.pixelToScreen(val * TILE_SIZE);
  }
  static tileToPixels(val = 0) {
    return val * TILE_SIZE;
  }
  static pixelToScreen(val = 0) {
    return val * SCALE;
  }
}
